import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appShortTable]'
})
export class ShortTableDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) { }
 
  @HostListener('click', ['$event.target'])
  onClick(target: any) {
    const th = this.findClosestHeader(target);
    if (!th || th.textContent.trim() === 'Action') {
      return;
    }
    const columnIndex = Array.from(th.parentElement.children).indexOf(th);
    const isAscending = th.classList.contains('sorted-asc');
    this.sortTable(columnIndex, !isAscending);
  }
 
  private findClosestHeader(element: any): HTMLElement | null {
    while (element && element.nodeName !== 'TH') {
      element = element.parentElement;
    }
    return element;
  }
 
  private sortTable(column: number, isAscending: boolean) {
    const table = this.el.nativeElement.closest('table');
    if (!table) {
      console.error("Table not found.");
      return;
    }
 
    const tbody = table.querySelector('tbody');
    if (!tbody) {
      console.error("Table body not found.");
      return;
    }
 
    const rows = Array.from(tbody.querySelectorAll('tr'));
 
    rows.sort((a: HTMLTableRowElement, b: HTMLTableRowElement) => {
      const keyA = a.cells[column].textContent.trim();
      const keyB = b.cells[column].textContent.trim();
      const numA = parseFloat(keyA);
      const numB = parseFloat(keyB);
      return isNaN(numA) || isNaN(numB) ? keyA.localeCompare(keyB) : numA - numB;
    });
 
    const sortedRows = isAscending ? rows : rows.reverse();
 
    rows.forEach(row => tbody.removeChild(row));
    sortedRows.forEach(row => tbody.appendChild(row));
 
    this.updateSortIndicators(column, isAscending);
  }
 
 
 
private updateSortIndicators(column: number, isAscending: boolean) {
  const thElements = this.el.nativeElement.querySelectorAll('th');
 
  thElements.forEach((th, index) => {
    // Remove existing sort icons
    const existingIcons = th.querySelectorAll('.sort-icon');
    existingIcons.forEach(icon => {
      th.removeChild(icon);
    });
 
    this.renderer.removeClass(th, 'sorted-asc');
    this.renderer.removeClass(th, 'sorted-desc');
  });
 
  const thElement = thElements[column];
 
  const upIcon = isAscending ? 'fas fa-caret-up sort-icon fa-lg pull-right fa-1x' : 'fas fa-caret-up sort-icon disabled-icon fa-lg pull-right fa-1x';
  const downIcon = isAscending ? 'fas fa-caret-down sort-icon fa-lg disabled-icon pull-right fa-1x' : 'fas fa-caret-down sort-icon fa-lg pull-right fa-1x';
 
  // Create elements for the up and down icons
  const upIconElement = this.renderer.createElement('i');
  upIconElement.className = upIcon;
  this.renderer.setStyle(upIconElement, 'margin-top', '-0.2rem');
  this.renderer.setStyle(upIconElement, 'margin-left', '-0.3rem');
  this.renderer.setStyle(upIconElement, 'font-size', '1.1rem');
 
  const downIconElement = this.renderer.createElement('i');
  downIconElement.className = downIcon;
  this.renderer.setStyle(downIconElement, 'margin-top', '0.3rem');
  this.renderer.setStyle(downIconElement, 'font-size', '1.1rem');
  this.renderer.setStyle(downIconElement, 'margin-right', '-0.4rem');
 
  // Add icons to the header element
  this.renderer.appendChild(thElement, upIconElement);
  this.renderer.appendChild(thElement, downIconElement);
 
  // Add sorted class to header element
  this.renderer.addClass(thElement, isAscending ? 'sorted-asc' : 'sorted-desc');
}
}
